<template>
  <div>
    <nav>
      <div
        class="nav nav-tabs nav-pills nav-fill p-2"
        id="nav-tab"
        role="tablist"
      >
        <button
          class="nav-link active rounded-0 btn-sm"
          id="nav-home-tab"
          data-bs-toggle="tab"
          data-bs-target="#nav-home"
          type="button"
          aria-selected="true"
        >
          DSEX
        </button>
        <button
          class="nav-link rounded-0 btn-sm"
          id="nav-profile-tab"
          data-bs-toggle="tab"
          data-bs-target="#nav-profile"
          type="button"
          aria-selected="false"
        >
          DSES
        </button>
        <button
          class="nav-link rounded-0 btn-sm"
          id="nav-contact-tab"
          data-bs-toggle="tab"
          data-bs-target="#nav-contact"
          type="button"
          aria-selected="false"
        >
          DS30
        </button>
        <button
          class="nav-link rounded-0 btn-sm"
          id="nav-cdset-tab"
          data-bs-toggle="tab"
          data-bs-target="#nav-cdset"
          type="button"
          aria-selected="false"
        >
          CDSET
        </button>
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
      <div
        class="tab-pane fade show active"
        id="nav-home"
        aria-labelledby="nav-home-tab"
      >
        <dsex-graph></dsex-graph>
      </div>
      <div
        class="tab-pane fade"
        id="nav-profile"
        aria-labelledby="nav-profile-tab"
      >
        <dses-graph></dses-graph>
      </div>
      <div
        class="tab-pane fade"
        id="nav-contact"
        aria-labelledby="nav-contact-tab"
      >
        <ds-30-graph></ds-30-graph>
      </div>
      <div class="tab-pane fade" id="nav-cdset" aria-labelledby="nav-cdset-tab">
        <ds-30-graph></ds-30-graph>
      </div>
    </div>
  </div>
</template>

<script>
import DsexGraph from "./DsexGraph.vue";
import DsesGraph from "./DsesGraph.vue";
import Ds30Graph from "./Ds30Graph.vue";
export default {
  components: {
    DsexGraph,
    DsesGraph,
    Ds30Graph,
  },
};
</script>

<style>
/* bootstrap hack: fix content width inside hidden tabs */
.tab-content > .tab-pane,
.pill-content > .pill-pane {
  display: block; /* undo display:none          */
  height: 0; /* height:0 is also invisible */
  overflow-y: hidden; /* no-overflow                */
}
.tab-content > .active,
.pill-content > .active {
  height: auto; /* let the content decide it  */
} /* bootstrap hack end */
</style>
